import { EventType } from "src/app/model/event-type";

export class Event {
  eventId: string;
  title: string;
  eventType: EventType;
  description: string;
  date: Date;
  time: string;
  eventRepetitionId: string;
  report: string;
  authorId: string;
  galleryId: string;
  cancelled: boolean;
}